// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════
   UGC Mobile Creator — slide-based wizard
   Mobile-first, uses project design tokens
   ═══════════════════════════════════════════════════ */

.ugcm-page {
  position: fixed;
  inset: 0;
  display: flex;
  flex-direction: column;
  background: var(--color-bg-root);
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  -webkit-font-smoothing: antialiased;
  overflow: hidden;
}

.ugcm-hidden-input {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  pointer-events: none;
}

/* ─── Header with progress ─── */

.ugcm-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px clamp(16px, 4vw, 24px);
  border-bottom: 1px solid var(--color-border-input);
  flex-shrink: 0;
}

.ugcm-header-logo {
  height: 20px;
  width: auto;
}

.ugcm-progress {
  flex: 1 1;
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
}

.ugcm-progress-dot {
  height: 3px;
  flex: 1 1;
  max-width: 48px;
  border-radius: 2px;
  background: var(--color-bg-input);
  transition: background 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.ugcm-progress-dot--active {
  background: var(--color-accent-base);
}

.ugcm-progress-dot--current {
  background: var(--color-accent-strong);
}

.ugcm-header-step {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  min-width: 28px;
  text-align: right;
}

/* ─── Slide container ─── */

.ugcm-main {
  flex: 1 1;
  position: relative;
  overflow: hidden;
  min-height: 0;
}

.ugcm-slides-panel {
  position: absolute;
  inset: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.ugcm-slides-panel--active {
  opacity: 1;
  pointer-events: auto;
}

/* ─── Individual slides ─── */

.ugcm-slide {
  padding: 28px clamp(20px, 5vw, 32px) 40px;
  max-width: 480px;
  margin: 0 auto;
  box-sizing: border-box;
}

.ugcm-slide-title {
  font-family: 'Geist Sans', Georgia, serif;
  font-size: clamp(26px, 5vw, 34px);
  font-weight: 400;
  line-height: 1.15;
  margin: 0 0 8px;
}

.ugcm-slide-desc {
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-text-secondary);
  margin: 0 0 24px;
}

/* ─── Character grid ─── */

.ugcm-char-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.ugcm-char-card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  padding: 0;
  border-radius: 10px;
  border: 2px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.15s ease;
}

.ugcm-char-card:active {
  transform: scale(0.96);
}

.ugcm-char-card--selected {
  border-color: var(--color-accent-base);
}

.ugcm-char-img {
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  display: block;
  background: var(--color-bg-input);
}

.ugcm-char-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-align: center;
  padding: 6px 4px;
}

.ugcm-char-card--selected .ugcm-char-name {
  color: var(--color-accent-base);
}

.ugcm-char-upload-icon {
  width: 100%;
  aspect-ratio: 3 / 4;
  background: var(--color-bg-input);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-secondary);
}

/* ─── Product grid ─── */

.ugcm-product-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.ugcm-product-card {
  position: relative;
  aspect-ratio: 1;
  border-radius: 10px;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
}

.ugcm-product-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.ugcm-product-remove {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.ugcm-product-add {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  aspect-ratio: 1;
  border-radius: 10px;
  border: 2px dashed var(--color-border-input);
  background: transparent;
  color: var(--color-text-secondary);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: border-color 0.2s ease;
}

.ugcm-product-add:active {
  border-color: var(--color-accent-base);
  color: var(--color-accent-base);
}

/* ─── Textarea ─── */

.ugcm-textarea {
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-canvas-surface);
  color: var(--color-text-primary);
  font-family: inherit;
  font-size: 15px;
  line-height: 1.55;
  resize: vertical;
  min-height: 140px;
  outline: none;
  transition: border-color 0.2s ease;
}

.ugcm-textarea::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.6;
}

.ugcm-textarea:focus {
  border-color: var(--color-accent-base);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

/* ─── Toggle ─── */

.ugcm-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  cursor: pointer;
}

.ugcm-toggle-label {
  font-size: 15px;
  font-weight: 500;
}

.ugcm-toggle {
  position: relative;
  width: 48px;
  height: 28px;
  border-radius: 14px;
  border: none;
  background: var(--color-bg-input);
  cursor: pointer;
  padding: 0;
  transition: background 0.2s ease;
}

.ugcm-toggle--on {
  background: var(--color-accent-base);
}

.ugcm-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.ugcm-toggle--on .ugcm-toggle-thumb {
  transform: translateX(20px);
}

/* ─── Review list ─── */

.ugcm-review-list {
  display: flex;
  flex-direction: column;
}

.ugcm-review-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--color-border-input);
}

.ugcm-review-item:last-child {
  border-bottom: none;
}

.ugcm-review-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  flex-shrink: 0;
  padding-top: 1px;
}

.ugcm-review-value {
  font-size: 14px;
  text-align: right;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ugcm-review-value--desc {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.45;
}

.ugcm-review-thumb {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
}

/* ─── Error bar ─── */

.ugcm-error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px clamp(16px, 4vw, 24px);
  background: var(--color-status-error-surface);
  border-top: 1px solid var(--color-status-error-border);
  flex-shrink: 0;
}

.ugcm-error p {
  margin: 0;
  font-size: 13px;
  color: var(--color-status-error-text);
  line-height: 1.4;
}

.ugcm-error button {
  border: none;
  background: none;
  color: var(--color-status-error-text);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: underline;
}

/* ─── Bottom nav ─── */

.ugcm-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px clamp(16px, 4vw, 24px);
  padding-bottom: max(12px, env(safe-area-inset-bottom));
  border-top: 1px solid var(--color-border-input);
  background: var(--color-bg-root);
  flex-shrink: 0;
}

.ugcm-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 6px;
  border: 1px solid var(--color-border-input);
  background: transparent;
  color: var(--color-text-primary);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}

.ugcm-btn-back:active {
  background: var(--color-bg-user-bubble);
}

.ugcm-btn-next {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 12px 24px;
  border-radius: 6px;
  border: none;
  background: var(--color-text-primary);
  color: var(--color-bg-canvas-surface);
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
  margin-left: auto;
}

.ugcm-btn-next:active {
  transform: scale(0.97);
}

.ugcm-btn-next:disabled {
  opacity: 0.35;
  cursor: default;
}

.ugcm-btn-next:disabled:active {
  transform: none;
}

.ugcm-btn-next--submit {
  background: var(--color-accent-base);
  color: #fff;
}

/* ─── Spinner ─── */

.ugcm-spinner {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: ugcmSpin 0.6s linear infinite;
}

@keyframes ugcmSpin {
  to { transform: rotate(360deg); }
}

/* ─── Generating / success slide ─── */

.ugcm-slide--generating {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 60vh;
}

.ugcm-gen-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.ugcm-gen-icon--success {
  background: rgba(34, 197, 94, 0.12);
  color: #22c55e;
  animation: ugcmPopIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;
}

@keyframes ugcmPopIn {
  from { transform: scale(0); opacity: 0; }
  to   { transform: scale(1); opacity: 1; }
}

.ugcm-gen-spinner {
  display: block;
  width: 32px;
  height: 32px;
  border: 3px solid color-mix(in srgb, var(--color-accent-base) 25%, transparent);
  border-top-color: var(--color-accent-base);
  border-radius: 50%;
  animation: ugcmSpin 0.7s linear infinite;
}

.ugcm-slide--generating .ugcm-slide-title {
  margin-bottom: 8px;
}

.ugcm-slide--generating .ugcm-slide-desc {
  max-width: 340px;
  margin-left: auto;
  margin-right: auto;
  white-space: pre-line;
}

.ugcm-gen-cta {
  margin: 28px auto 0;
  justify-content: center;
  min-width: 220px;
}

.ugcm-gen-icon--error {
  background: var(--color-status-error-surface);
  color: var(--color-status-error-text);
}

.ugcm-oauth-banner {
  padding: 10px clamp(16px, 4vw, 24px);
  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);
  border-bottom: 1px solid color-mix(in srgb, var(--color-accent-base) 35%, transparent);
  color: var(--color-accent-base);
  font-size: 13px;
  font-weight: 500;
  text-align: center;
  flex-shrink: 0;
}

/* ═══════════════════════════════════════════
   Tablet+ (≥ 600px)
   ═══════════════════════════════════════════ */

@media (min-width: 600px) {
  .ugcm-slide {
    padding-top: 48px;
    max-width: 520px;
  }

  .ugcm-char-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 14px;
  }

  .ugcm-product-grid {
    grid-template-columns: repeat(4, 1fr);
  }

}

/* ═══════════════════════════════════════════
   Desktop (≥ 900px) - still centered single col
   ═══════════════════════════════════════════ */

@media (min-width: 900px) {
  .ugcm-slide {
    padding-top: 64px;
    max-width: 560px;
  }

  .ugcm-slide-title {
    font-size: 36px;
  }

  .ugcm-header {
    padding: 14px 32px;
  }

  .ugcm-footer {
    padding: 14px 32px;
    padding-bottom: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/UgcMobilePage.css"],"names":[],"mappings":"AAAA;;;wDAGwD;;AAExD;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,gCAAgC;EAChC,8EAA8E;EAC9E,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oCAAoC;EACpC,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,eAAe;EACf,kBAAkB;EAClB,iCAAiC;EACjC,yDAAyD;AAC3D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA,4BAA4B;;AAE5B;EACE,SAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,UAAU;EACV,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA,8BAA8B;;AAE9B;EACE,yCAAyC;EACzC,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;AACpC;;AAEA,yBAAyB;;AAEzB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,4CAA4C;EAC5C,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA,qBAAqB;;AAErB;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,0CAA0C;EAC1C,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA,mBAAmB;;AAEnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;;AAEtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,sDAAsD;EACtD,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,uBAAuB;;AAEvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oCAAoC;EACpC,sDAAsD;EACtD,+CAA+C;EAC/C,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA,oBAAoB;;AAEpB;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,uCAAuC;;AAEvC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yEAAyE;EACzE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gEAAgE;AAClE;;AAEA;EACE,OAAO,mBAAmB,EAAE,UAAU,EAAE;EACxC,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+EAA+E;EAC/E,0CAA0C;EAC1C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,yEAAyE;EACzE,sFAAsF;EACtF,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;gDAEgD;;AAEhD;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;AAEF;;AAEA;;gDAEgD;;AAEhD;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF","sourcesContent":["/* ═══════════════════════════════════════════════════\n   UGC Mobile Creator — slide-based wizard\n   Mobile-first, uses project design tokens\n   ═══════════════════════════════════════════════════ */\n\n.ugcm-page {\n  position: fixed;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--color-bg-root);\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden;\n}\n\n.ugcm-hidden-input {\n  position: absolute;\n  width: 0;\n  height: 0;\n  opacity: 0;\n  pointer-events: none;\n}\n\n/* ─── Header with progress ─── */\n\n.ugcm-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px clamp(16px, 4vw, 24px);\n  border-bottom: 1px solid var(--color-border-input);\n  flex-shrink: 0;\n}\n\n.ugcm-header-logo {\n  height: 20px;\n  width: auto;\n}\n\n.ugcm-progress {\n  flex: 1;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n}\n\n.ugcm-progress-dot {\n  height: 3px;\n  flex: 1;\n  max-width: 48px;\n  border-radius: 2px;\n  background: var(--color-bg-input);\n  transition: background 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ugcm-progress-dot--active {\n  background: var(--color-accent-base);\n}\n\n.ugcm-progress-dot--current {\n  background: var(--color-accent-strong);\n}\n\n.ugcm-header-step {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  min-width: 28px;\n  text-align: right;\n}\n\n/* ─── Slide container ─── */\n\n.ugcm-main {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  min-height: 0;\n}\n\n.ugcm-slides-panel {\n  position: absolute;\n  inset: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  -webkit-overflow-scrolling: touch;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ugcm-slides-panel--active {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n/* ─── Individual slides ─── */\n\n.ugcm-slide {\n  padding: 28px clamp(20px, 5vw, 32px) 40px;\n  max-width: 480px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n.ugcm-slide-title {\n  font-family: 'Geist Sans', Georgia, serif;\n  font-size: clamp(26px, 5vw, 34px);\n  font-weight: 400;\n  line-height: 1.15;\n  margin: 0 0 8px;\n}\n\n.ugcm-slide-desc {\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--color-text-secondary);\n  margin: 0 0 24px;\n}\n\n/* ─── Character grid ─── */\n\n.ugcm-char-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.ugcm-char-card {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n  padding: 0;\n  border-radius: 10px;\n  border: 2px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  cursor: pointer;\n  overflow: hidden;\n  transition: border-color 0.2s ease, transform 0.15s ease;\n}\n\n.ugcm-char-card:active {\n  transform: scale(0.96);\n}\n\n.ugcm-char-card--selected {\n  border-color: var(--color-accent-base);\n}\n\n.ugcm-char-img {\n  width: 100%;\n  aspect-ratio: 3 / 4;\n  object-fit: cover;\n  display: block;\n  background: var(--color-bg-input);\n}\n\n.ugcm-char-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-align: center;\n  padding: 6px 4px;\n}\n\n.ugcm-char-card--selected .ugcm-char-name {\n  color: var(--color-accent-base);\n}\n\n.ugcm-char-upload-icon {\n  width: 100%;\n  aspect-ratio: 3 / 4;\n  background: var(--color-bg-input);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--color-text-secondary);\n}\n\n/* ─── Product grid ─── */\n\n.ugcm-product-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.ugcm-product-card {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n}\n\n.ugcm-product-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.ugcm-product-remove {\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.ugcm-product-add {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  aspect-ratio: 1;\n  border-radius: 10px;\n  border: 2px dashed var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-secondary);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: border-color 0.2s ease;\n}\n\n.ugcm-product-add:active {\n  border-color: var(--color-accent-base);\n  color: var(--color-accent-base);\n}\n\n/* ─── Textarea ─── */\n\n.ugcm-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  padding: 14px 16px;\n  border-radius: 10px;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-canvas-surface);\n  color: var(--color-text-primary);\n  font-family: inherit;\n  font-size: 15px;\n  line-height: 1.55;\n  resize: vertical;\n  min-height: 140px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.ugcm-textarea::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.6;\n}\n\n.ugcm-textarea:focus {\n  border-color: var(--color-accent-base);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n/* ─── Toggle ─── */\n\n.ugcm-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 0;\n  cursor: pointer;\n}\n\n.ugcm-toggle-label {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.ugcm-toggle {\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: 14px;\n  border: none;\n  background: var(--color-bg-input);\n  cursor: pointer;\n  padding: 0;\n  transition: background 0.2s ease;\n}\n\n.ugcm-toggle--on {\n  background: var(--color-accent-base);\n}\n\n.ugcm-toggle-thumb {\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ugcm-toggle--on .ugcm-toggle-thumb {\n  transform: translateX(20px);\n}\n\n/* ─── Review list ─── */\n\n.ugcm-review-list {\n  display: flex;\n  flex-direction: column;\n}\n\n.ugcm-review-item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 0;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.ugcm-review-item:last-child {\n  border-bottom: none;\n}\n\n.ugcm-review-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n  padding-top: 1px;\n}\n\n.ugcm-review-value {\n  font-size: 14px;\n  text-align: right;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ugcm-review-value--desc {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.45;\n}\n\n.ugcm-review-thumb {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n/* ─── Error bar ─── */\n\n.ugcm-error {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px clamp(16px, 4vw, 24px);\n  background: var(--color-status-error-surface);\n  border-top: 1px solid var(--color-status-error-border);\n  flex-shrink: 0;\n}\n\n.ugcm-error p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--color-status-error-text);\n  line-height: 1.4;\n}\n\n.ugcm-error button {\n  border: none;\n  background: none;\n  color: var(--color-status-error-text);\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  text-decoration: underline;\n}\n\n/* ─── Bottom nav ─── */\n\n.ugcm-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px clamp(16px, 4vw, 24px);\n  padding-bottom: max(12px, env(safe-area-inset-bottom));\n  border-top: 1px solid var(--color-border-input);\n  background: var(--color-bg-root);\n  flex-shrink: 0;\n}\n\n.ugcm-btn-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 6px;\n  border: 1px solid var(--color-border-input);\n  background: transparent;\n  color: var(--color-text-primary);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.ugcm-btn-back:active {\n  background: var(--color-bg-user-bubble);\n}\n\n.ugcm-btn-next {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 24px;\n  border-radius: 6px;\n  border: none;\n  background: var(--color-text-primary);\n  color: var(--color-bg-canvas-surface);\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.15s ease, opacity 0.15s ease;\n  margin-left: auto;\n}\n\n.ugcm-btn-next:active {\n  transform: scale(0.97);\n}\n\n.ugcm-btn-next:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n\n.ugcm-btn-next:disabled:active {\n  transform: none;\n}\n\n.ugcm-btn-next--submit {\n  background: var(--color-accent-base);\n  color: #fff;\n}\n\n/* ─── Spinner ─── */\n\n.ugcm-spinner {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: ugcmSpin 0.6s linear infinite;\n}\n\n@keyframes ugcmSpin {\n  to { transform: rotate(360deg); }\n}\n\n/* ─── Generating / success slide ─── */\n\n.ugcm-slide--generating {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: 60vh;\n}\n\n.ugcm-gen-icon {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.ugcm-gen-icon--success {\n  background: rgba(34, 197, 94, 0.12);\n  color: #22c55e;\n  animation: ugcmPopIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n}\n\n@keyframes ugcmPopIn {\n  from { transform: scale(0); opacity: 0; }\n  to   { transform: scale(1); opacity: 1; }\n}\n\n.ugcm-gen-spinner {\n  display: block;\n  width: 32px;\n  height: 32px;\n  border: 3px solid color-mix(in srgb, var(--color-accent-base) 25%, transparent);\n  border-top-color: var(--color-accent-base);\n  border-radius: 50%;\n  animation: ugcmSpin 0.7s linear infinite;\n}\n\n.ugcm-slide--generating .ugcm-slide-title {\n  margin-bottom: 8px;\n}\n\n.ugcm-slide--generating .ugcm-slide-desc {\n  max-width: 340px;\n  margin-left: auto;\n  margin-right: auto;\n  white-space: pre-line;\n}\n\n.ugcm-gen-cta {\n  margin: 28px auto 0;\n  justify-content: center;\n  min-width: 220px;\n}\n\n.ugcm-gen-icon--error {\n  background: var(--color-status-error-surface);\n  color: var(--color-status-error-text);\n}\n\n.ugcm-oauth-banner {\n  padding: 10px clamp(16px, 4vw, 24px);\n  background: color-mix(in srgb, var(--color-accent-base) 12%, transparent);\n  border-bottom: 1px solid color-mix(in srgb, var(--color-accent-base) 35%, transparent);\n  color: var(--color-accent-base);\n  font-size: 13px;\n  font-weight: 500;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n/* ═══════════════════════════════════════════\n   Tablet+ (≥ 600px)\n   ═══════════════════════════════════════════ */\n\n@media (min-width: 600px) {\n  .ugcm-slide {\n    padding-top: 48px;\n    max-width: 520px;\n  }\n\n  .ugcm-char-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 14px;\n  }\n\n  .ugcm-product-grid {\n    grid-template-columns: repeat(4, 1fr);\n  }\n\n}\n\n/* ═══════════════════════════════════════════\n   Desktop (≥ 900px) - still centered single col\n   ═══════════════════════════════════════════ */\n\n@media (min-width: 900px) {\n  .ugcm-slide {\n    padding-top: 64px;\n    max-width: 560px;\n  }\n\n  .ugcm-slide-title {\n    font-size: 36px;\n  }\n\n  .ugcm-header {\n    padding: 14px 32px;\n  }\n\n  .ugcm-footer {\n    padding: 14px 32px;\n    padding-bottom: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
